import { inject, injectable } from "@launchtray/tsyringe-async";
import { Container, Text, TextStyle, utils } from "pixi.js";
import { NotificationLayerProvider } from "../../../composition/providers/NotificationLayerProvider";
import { ICanvasScaler } from "../../../../canvas/ICanvasScaler";
import { FixedSizeContainer } from "./FixedSizeContainer";
import { FadeScreen } from "../../game/components/FadeScreen";

@injectable()
export class AcceptOperationNotification extends Container {
    private static readonly MESSAGE_TEXT_FORMAT = `Please accept action in your {0} wallet\n${utils.isMobile.any ? "application" : "extension"}`;

    private readonly canvasScaler: ICanvasScaler;
    private readonly notificationLayerProvider: NotificationLayerProvider;
    private readonly uiContainer: FixedSizeContainer;
    private readonly message: Text;

    public constructor(
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        notificationLayerProvider: NotificationLayerProvider
    ) {
        super();
        this.canvasScaler = canvasScaler;
        this.notificationLayerProvider = notificationLayerProvider;
        const width = canvasScaler.referenceWidth;
        const height = canvasScaler.referenceHeight;
        this.uiContainer = new FixedSizeContainer(width, height);
        this.addChild(this.uiContainer);
        const fader = new FadeScreen(0.1, 0.0, 0.7, width, height);
        fader.position.set(0, 0);
        fader.fadeIn();
        this.uiContainer.addChild(fader);

        this.message = new Text(AcceptOperationNotification.MESSAGE_TEXT_FORMAT, new TextStyle({
            fontSize: 40,
            fill: 0xFFFFFF,
            align: "center",
            stroke: 0x000000,
            strokeThickness: 4
        }));
        this.layoutText();
        this.uiContainer.addChild(this.message);

        this.notificationLayerProvider.notificationLayer.addChild(this);
        this.hide();
    }

    public show(walletName: string): void {
        this.message.text = AcceptOperationNotification.MESSAGE_TEXT_FORMAT.replace('{0}', walletName);
        this.uiContainer.alpha = 1;
        this.eventMode = "dynamic";
        this.layoutText();
    }

    public hide(): void {
        this.uiContainer.alpha = 0;
        this.eventMode = "none";
    }

    public async autoShowHide<T>(operation: Promise<T>, walletName: string): Promise<T> {
        this.show(walletName);
        try {
            return await operation;
        }
        catch (e: unknown) {
            throw e;
        }
        finally {
            this.hide();
        }
    }

    private layoutText(): void {
        this.message.scale.set(1);
        if (this.message.width > this.canvasScaler.referenceWidth + 50) {
            this.message.scale.set((this.canvasScaler.referenceWidth + 50) / this.message.width);
        }
        this.message.position.set((this.canvasScaler.referenceWidth - this.message.width) * 0.5, this.canvasScaler.referenceHeight * 0.5 - this.message.height);
    }
}